import { SET_TOGGLE_STATE } from '../actions/toggles'

const initialState = {
  'squad-body': false,
  'stats-body': false
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOGGLE_STATE:
      return {
        ...state,
        [action.payload.toggleId]: action.payload.active
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/toggles.js